<template>
    <v-form 
        v-model="valid" 
        ref="form" 
        :disabled="props.disabled || resolvedIsSubmitCallPending" 
        :loading="resolvedIsLoadingTrackingGroup || resolvedIsSubmitCallPending"
        :readonly="readonlyFields"
        :style="props.standalone ? 'max-width:960px; margin-inline: auto;' : ''"
    >
        <v-alert
            v-if="props.standalone && standaloneAlert"
            :variant="standaloneAlert?.variant ?? 'tonal'"
            :color="standaloneAlert?.color ?? 'error'"
            :title="standaloneAlert?.title ?? 'Erro'"
            :text="standaloneAlert?.text ?? standaloneAlert?.message"
            style="white-space: pre;"
            closable
            class="my-6"
        />
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-text-field 
                    v-model="formValues.name" 
                    label="Nome*" 
                    variant="outlined"
                    :clearable="!readonlyFields" 
                    :readonly="readonlyFields" 
                    :disabled="props.disabled || resolvedIsSubmitCallPending || resolvedIsLoadingTrackingGroup" 
                    :loading="resolvedIsLoadingTrackingGroup" 
                    :rules="[
                        formValidationRules.required(
                            formValues.name
                        ),
                    ]"
                />
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-textarea
                    v-model="formValues.description"
                    label="Descrição"
                    variant="outlined"
                    :clearable="!readonlyFields"
                    :readonly="readonlyFields" 
                    :disabled="props.disabled || resolvedIsSubmitCallPending || resolvedIsLoadingTrackingGroup" 
                    :loading="resolvedIsLoadingTrackingGroup" 
                    :rules="[]"
                />
            </v-col>
        </v-row>
        
        <!-- <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-autocomplete 
                    v-model="formValues.tracker_user_ids"
                    label="Acompanhante(s) do Grupo*"
                    variant="outlined"
                    :clearable="!readonlyFields"
                    :readonly="readonlyFields"
                    :disabled="props.disabled || resolvedIsSubmitCallPending"
                    :loading="resolvedIsLoadingUsersList"
                    :items="managingUsersList"
                    item-value="id"
                    :item-title="(item) => `${item?.worker_code || 'Sem código'} - ${item?.name || 'Sem Nome'}`"
                    multiple
                    :rules="[
                        formValidationRules.required(formValues.tracker_user_ids),
                        formValidationRules.cannotIntersect(
                            formValues.tracker_user_ids,
                            formValues.tracked_user_ids,
                        )
                    ]"
                    
                    :hint="
                        !readonlyFields
                        ? 'Colaborador(es) que podem ver os membros (seguidos) pelo grupo.'
                        : undefined    
                    "
                    :persistent-hint="!readonlyFields"
                />
            </v-col>
        </v-row> -->
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-autocomplete 
                    v-model="formValues.tracked_user_ids"
                    label="Membros(s) Seguido(s) pelo Grupo*"
                    variant="outlined"
                    autocomplete="off"
                    chips
                    closable-chips
                    :clearable="!readonlyFields"
                    :readonly="readonlyFields"
                    :disabled="props.disabled || resolvedIsSubmitCallPending || resolvedIsLoadingUsersList  || resolvedIsLoadingTrackingGroup"
                    :loading="resolvedIsLoadingUsersList"
                    :items="resolvedUsersList"
                    item-value="id"
                    :item-title="(item) => `${item?.worker_code || 'Sem código'} - ${item?.name || 'Sem Nome'}`"
                    multiple
                    :rules="[
                        formValidationRules.required(formValues.tracked_user_ids),
                        formValidationRules.cannotIntersect(
                            formValues.tracked_user_ids,
                            formValues.manager_user_ids,
                            resolvedUsersListById,
                            'Gestor(es) do Grupo*'
                        )
                    ]"
                    :menu-icon="readonlyFields ? '' : undefined"
                    :hint="
                        !readonlyFields
                        ? 'Colaborador(es) que ficam visíveis para os \'Gestores\' no contexto das MBTs.'
                        : undefined    
                    "
                    :persistent-hint="!readonlyFields"
                />
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col class="px-0" cols="12">
                <v-autocomplete 
                    v-model="formValues.manager_user_ids"
                    label="Gestor(es) do Grupo*"
                    variant="outlined"
                    autocomplete="off"
                    chips
                    closable-chips
                    :clearable="!readonlyFields"
                    :readonly="readonlyFields"
                    :disabled="props.disabled || resolvedIsSubmitCallPending || resolvedIsLoadingManagers  || resolvedIsLoadingTrackingGroup"
                    :loading="resolvedIsLoadingManagers"
                    :items="resolvedManagerUsersList"
                    item-value="id"
                    :item-title="(item) => `${item?.worker_code || 'Sem código'} - ${item?.name || 'Sem Nome'}`"
                    multiple
                    :rules="[
                        formValidationRules.required(formValues.manager_user_ids),
                        // formValidationRules.cannotIntersect(
                        //     formValues.manager_user_ids,
                        //     formValues.tracked_user_ids,
                        //     resolvedUsersListById,
                        // )
                    ]"
                    :hint="
                        !readonlyFields
                        ? 'Colaborador(es) que podem editar / apagar o grupo e vêm os membros do grupo sem restrições de CCs ou outras permissões.'
                        : undefined    
                    "
                    :menu-icon="readonlyFields ? '' : undefined"
                    :persistent-hint="!readonlyFields"
                />
            </v-col>
        </v-row>
        <v-row class="ma-0" v-if="props.standalone">
            <v-alert
                v-if="validationError?.title || validationError?.message"
                variant="tonal"
                :color="validationError?.color || 'error'"
                :title="validationError?.title"
                :text="validationError?.message"
                style="white-space: pre;"
            ></v-alert>
            <v-col 
                cols="12"
                class="px-0 d-flex justify-end"
                v-if="resolveHasSubmitButton"
            >
                <v-btn 
                    v-if="!actionIsDelete()"
                    color="success" 
                    class="text-none"
                    :prepend-icon="
                        resolvedIsSubmitCallPending 
                        ? 'mdi-loading mdi-spin' 
                        : (
                            ['new', 'create'].includes(localAction)
                            ? 'mdi-plus'
                            : 'mdi-content-save'
                        )"
                    :disabled="localIsSubmitting  || resolvedIsLoadingTrackingGroup"
                    @click="submit"
                >
                    {{ 
                        resolvedIsSubmitCallPending  
                        ? (
                            ["new", "create"].includes(localAction)
                            ? "Criando"
                            : "Atualizando"
                        ) 
                        : (
                            ["new", "create"].includes(localAction)
                            ? "Criar"
                            : "Atualizar"
                        )
                    }} Grupo{{ resolvedIsSubmitCallPending ? '...' : '' }}
                </v-btn>
                <v-btn
                    v-if="actionIsDelete()"
                    color="error"
                    class="text-none"
                    :prepend-icon="
                        resolvedIsSubmitCallPending
                        ? 'mdi-loading mdi-spin'
                        : 'mdi-delete'
                    "
                    :disabled="localIsSubmitting  || resolvedIsLoadingTrackingGroup"
                    @click="submit"
                >
                    {{ 
                        resolvedIsSubmitCallPending  
                        ? 'Apagando' 
                        : 'Apagar'
                    }} Grupo{{ resolvedIsSubmitCallPending ? '...' : '' }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>
<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';
import formValidationRules from '../../../../../composables/formValidationRules';
import { useSessionStore } from '../../../../../stores/SessionStore';
import DmrTrackingGroups from '../../../../../api/departments/membership-requests/tracking-groups/DmrTrackingGroups';
import User from '../../../../../api/User';
import router from '../../../../../router';

const props = defineProps({
    disabled : {
        type: Boolean,
        default: false,
    },
    readonly : {
        type: Boolean,
        default: false,
    },
    action: {
        type: String,
        default: "create",
        validator(value, props) {
            return [
                "create",
                "new",
                "read",
                "get",
                "show",
                "edit",
                "update",
                "delete",
                "remove"
            ].includes(value);
        },
    },
    trackingGroupId : {
        type: String,
        default: null,
    },
    trackingGroupObject: {
        type: Object,
        default: null,
    },
    isSubmitting : {
        type: Boolean,
        default: false,
    },
    isFetchingTrackingGroup: {
        type: Boolean,
        default: false,
    },
    usersList : {
        type: Array,
        default: null,
    },
    isFetchingUsersList: {
        type: Boolean,
        default: false,
    },
    standalone: {
        type: Boolean,
        default: false,
    },
    managersList: {
        type: Array,
        default: null,
    },
    isFetchingManagersList : {
        type: Boolean,
        default: false,
    },
});

defineExpose({
    validate,
    submit,
});

const sessionStore = useSessionStore();

const formValues = ref({
    // id: null,
    name: props?.trackingGroupObject?.name ?? null,
    description: props?.trackingGroupObject?.description ?? null,
    manager_user_ids: props?.trackingGroupObject?.manager_user_ids ?? null,
    // tracker_user_ids: null,
    tracked_user_ids:  props?.trackingGroupObject?.tracked_user_ids ?? null,
});
const valid = ref(false);
const form = ref("form");
const validationError = ref({});
const standaloneAlert = ref(null);

const localIsSubmitting = ref(false);
const localIsFetchingTrackingGroup = ref(false);
const localUsersList = ref([]);
const localIsFetchingUsersList = ref(false);
const localManagersList = ref([]);
const localIsFetchingManagersList = ref(false);

const localTrackingGroupId = ref(props?.trackingGroupObject?.id ?? props?.trackingGroupId ?? null);
const localAction = ref(props?.action);

const readonlyFields = computed(() => {
    if(props.readonly) {
        return true;
    }
    if(
        [
            "read",
            "show",
            "get",
            "delete",
            "remove",
        ].includes(localAction.value)
    ) {
        return true;
    }
    return false;
});

const actionLabel = computed(() => {
    switch (localAction.value) {
        case "create":
        case "new":
            return "criar";
        
        case "update":
        case "edit":
            return "editar";
        
        case "remove":
        case "delete":
            return "apagar";
    
        default:
            return "submeter";
    }
});

const concludedActionLabel = computed(() => {
    switch (localAction.value) {
        
        
        case "update":
        case "edit":
            return "atualizado";
        
        case "remove":
        case "delete":
            return "apagado";
    
        case "create":
        case "new":
        default:
            return "criado";
    }
})

const resolvedIsSubmitCallPending = computed(() => {
    return props.isSubmitting 
            || localIsSubmitting.value;
});

const resolvedIsLoadingTrackingGroup = computed(() => {
    return props.isFetchingTrackingGroup 
            || localIsFetchingTrackingGroup.value;
});

const resolvedIsLoadingUsersList = computed(() => {
    return props.isFetchingUsersList
            || localIsFetchingUsersList.value;
});

const resolvedUsersList = computed(() => {

    let usersArray;
    if(props.usersList?.length > 0 || props.isFetchingUsersList) {
        usersArray = props.usersList;
    } else {
        usersArray = localUsersList.value
    }
    return usersArray?.filter((u) => !formValues.value.manager_user_ids?.includes(u?.id));
});

const resolvedUsersListById = computed(() => {
    return Object.fromEntries(
        resolvedUsersList.value?.map(
            (u) => {
                return u?.id ? [u?.id, (`${u.worker_code || 'Sem código'} - ${u?.name || 'Sem Nome'}`)] : null
            }
        ).filter(Boolean)
    )
});

const resolvedIsLoadingManagers = computed(() => {
    return props.isFetchingManagersList
            || localIsFetchingManagersList.value;
});

const resolvedManagerUsersList = computed(() => {
    if(props.managersList?.length > 0 || props.isFetchingManagersList) {
        return props.managersList;
    }
    return localManagersList.value;
});

async function validate() {
    const result = await form.value.validate();
    await nextTick();
    return result.valid;
    
}

async function submit() {
    if(resolvedIsSubmitCallPending.value) {
        return;
    }

    try {
        validationError.value = null;
        await nextTick();
        const shouldValidate = [
            "create",
            "new",
            "update",
            "edit",
        ].includes(localAction.value) 
        && !props.disabled
        && !readonlyFields.value
        ;

        if(shouldValidate) {
            const passedValidation = await validate();

            if(!passedValidation) {
                if(props.standalone) {
                    validationError.value = {
                        title: "Erro de Validação",
                        message: "Ocorreu pelo menos um erro de validação. Verifique as mensagens de erro nos campos assinalados."
                    };
                }
                const firstError = form.value.errors[0].id;
                const targetInput = document.getElementById(firstError);

                targetInput.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    container: "nearest",

                });
                targetInput.focus();

                return false;
            }
        }

        localIsSubmitting.value = true;
        standaloneAlert.value = null;

        const apiMethod = resolveApiMethod(localAction.value)

        const payload = resolveSubmitPayload(localAction.value);
        
        const response = await apiMethod(...(payload ?? []));

        if( props.standalone
            && (
                response?.status >= 200 
                && response?.status < 300
            
            )
        ) {
            standaloneAlert.value = {
                title: "Sucesso",
                message: `Grupo ${concludedActionLabel.value} com sucesso.`,
                color: "success"
            };

            router.push({
                name: "department-membership-request-tracking-groups-index"
            });
        }

    } catch (error) {
        
        let errorTypes = resolveRequestErrorType(error);
        let {
            failedValidation,
            forbidden,
            notFound
        } = errorTypes;
        let errorTitle = resolveRequestErrorTitle(error, errorTypes);        

        let errorMessage = resolveRequestErrorMessage(error, errorTypes);
        
        console.error(
            errorMessage,
            error
        );

        if(props.standalone) {
            validationError.value = {
                title: errorTitle,
                color: "error",
                message: errorMessage,
            };
            if(failedValidation || forbidden) {
                router.push({
                    name: "forbidden",
                })
            } else if(notFound) {
                router.push({
                    name: "not-found"
                })
            }
        }else {
            throw error;
        }
        return false;
    } finally {
        localIsSubmitting.value = false;
    }
}

function resolveRequestErrorTitle(error, errorTypes = null) {
    let errorTitle;
    
    let {
        failedValidation,
        forbidden,
        notFound
    } = errorTypes ?? resolveRequestErrorType(error);

    let actionIsGet = actionExecutesGet();
    if(failedValidation) {
        if(actionIsGet) {
            errorTitle = "Grupo inválido";
        } else {
            errorTitle = "Erro de Validação";
        }
    } else if(forbidden) {
        if (actionIsGet) {
            errorTitle = "Acesso Negado";
        } else {
            errorTitle = "Erro de Permissões";
        }
    } else if(notFound) {
        errorTitle = "Grupo não encontrado";
    } else {
        errorTitle = "Erro";
    }

    return errorTitle;
}

function resolveRequestErrorType(error) {
    return {
        failedValidation: error?.response?.status === 422,
        notFound: error?.response?.status === 404,
        forbidden: (
            error?.response?.status === 401
            || error?.response?.status === 403
        )
    }
}

function actionExecutesGet() {
    return [
                "read", 
                "get", 
                "show",
                "delete", 
                "remove"
            ].includes(localAction.value)
}

function resolveRequestErrorMessage(error, errorTypes = null) {

    let {
        failedValidation,
        forbidden,
        notFound
    } = errorTypes ?? resolveRequestErrorType(error);
    let actionIsGet = actionExecutesGet();
    let errorMessage;
    if(actionIsGet) {
        if(failedValidation) {
            errorMessage = "O id do grupo não é válido ou já foi apagado.";
        } else if(forbidden) {
            
            errorMessage = "Não possui permissões para ver a informação deste grupo";
        } else if(notFound) {
            errorMessage = "Não foi encontrado nenhum grupo com o id indicado."
        } else {
            errorMessage = "Ocorreu um erro a obter as informações do Grupo.";
            
        }
    } else {

        if(Object.values(error?.response?.data?.errors ?? {}).length > 0) {
    
            errorMessage = Object.values(error?.response?.data?.errors)
                            .flatMap((e) => e?.join("; "))?.join("\n");
    
        } else if(error?.response?.data?.message) {
    
            errorMessage = error?.response?.data?.message;
    
        } else {
    
            errorMessage = `Erro a ${actionLabel.value} grupo`;
    
        }
    }


    return errorMessage;
}

async function fetchUsers() {
    if(resolvedIsLoadingUsersList.value) {
        return;
    }

    try {
        localIsFetchingUsersList.value = true;

        const usersListResponse = await DmrTrackingGroups.listActiveUsers();

        localUsersList.value = usersListResponse?.data ?? [];
        
    } catch (error) {
        console.error(
            "Erro a carregar lista de Colaboradores activos",
            error,
        );
        
    } finally {
        localIsFetchingUsersList.value = false;
    }

}

async function fetchTrackingGroup() {

    if(resolvedIsLoadingTrackingGroup.value) {
        return;
    }

    try {
        localIsFetchingTrackingGroup.value = true;
        const targetId = localTrackingGroupId.value;

        if(!targetId) {

            return;
        }
        const trackingGroupResponse = await DmrTrackingGroups.show(targetId);
        const responseData = trackingGroupResponse?.data;
        localTrackingGroupId.value = responseData?.id ?? null;

        formValues.value = {
            name: responseData?.name,
            description: responseData?.description,
            tracked_user_ids: responseData?.tracked?.map((m) => m?.id)?.filter(Boolean),
            manager_user_ids: responseData?.managers?.map((m) => m?.id)?.filter(Boolean),
        }
    } catch (error) {
        console.error(
            "Ocorreu um erro a carregar as informações do grupo",
            error
        );
        let errorTypes = resolveRequestErrorType(error);
        let {
            failedValidation,
            forbidden,
            notFound
        } = errorTypes;
        let errorTitle = resolveRequestErrorTitle(error, errorTypes);        

        let errorMessage = resolveRequestErrorMessage(error, errorTypes);

        if(props.standalone) {
            validationError.value = {
                title: errorTitle,
                color: "error",
                message: errorMessage,
            };
            if(failedValidation || forbidden) {
                router.push({
                    name: "forbidden",
                })
            } else if(notFound) {
                router.push({
                    name: "not-found"
                })
            }
        }
    } finally {
        localIsFetchingTrackingGroup.value = false;
    }

}

function resolveApiMethod(action = localAction.value) {
    switch (action) {
        case "create":
        case "new":
            return (payload) => DmrTrackingGroups.create(payload);

        case "update":
        case "edit":
            return (id, payload) => DmrTrackingGroups.update(id, payload);

        case "get":
        case "show":
        case "read":
            return (id) => DmrTrackingGroups.show(id);

        case "delete":
        case "remove":
            return (id) => DmrTrackingGroups.delete(id);

        default:
            throw new RangeError(`A ação "${action}" não é válida.`);
    }
}

async function fetchEligibleManagersUsersList() {
    if(resolvedIsLoadingManagers.value) {
        return
    }

    try {
        localIsFetchingManagersList.value = true;

        const managersResponse = await DmrTrackingGroups.getEligibleManagers();

        localManagersList.value = managersResponse?.data ?? [];

    } catch (error) {
        console.error(
            "Ocorreu um erro a carregar a lista de gestores de grupo",
            error,
        );
    } finally {
        localIsFetchingManagersList.value = false;
    }
}

function resolveSubmitPayload(action = localAction.value) {
    
    if(
        [
            "update",
            "edit"
        ].includes(action)
    ) {
        return [
            localTrackingGroupId.value
            ,
            {
                ...formValues.value
            }
        ];
    }

    if(
        [
            "delete",
            "remove",
        ].includes(action)
    ) {
        return [
            localTrackingGroupId.value
        ]
    }

    if(
        [
            "create",
            "new"
        ].includes(action)
    ) {
        return [
            {
                ...formValues.value
            }
        ];
    }

    return null;
}

function resolveHasSubmitButton() {
    if(!props?.standalone) {
        return false;
    }

    if(
        [
            "get",
            "show",
            "read",
        ].includes(localAction.value)
    ) {
        return false;
    }

    if(
        [
            "new",
            "create",
            "edit",
            "update",
            "remove",
            "delete",
        ].includes(localAction.value) 
    ) {
        return true;
    }
    return false;
}

function actionIsDelete() {
    console.log(localAction.value);
    return ["delete", "remove"].includes(localAction.value);
}

onMounted(() => {
    // console.log(localAction.value);
    if( props.standalone
        && !sessionStore.hasPermission([
            "user.department.membership.request.tracking-group.create",
            "user.department.membership.request.tracking-group.update",
            "user.department.membership.request.tracking-group.delete",
            "user.department.membership.request.tracking-group.get",
            "user.department.membership.request.tracking-group.manage.manager",
            "user.department.membership.request.tracking-group.manage.tracked",
            "user.department.membership.request.tracking-group.manage.any"
        ])
    ) {
        router.push({
            name: "forbidden",
        });
    }
    if(
        !props.managersList?.length
        && !props.isFetchingManagersList
    ) {
        fetchEligibleManagersUsersList();
    }

    if(
        !props.usersList?.length 
        && !props.isFetchingUsersList
    ) {
        fetchUsers();
    }

    if(
        localTrackingGroupId.value
        
    ) {
        if(
            [
                "new",
                "create"
            ].includes(localAction.value)
        ) {
            localAction.value = "get"
        }
        
        if(
            !resolvedIsLoadingTrackingGroup.value
            || (
                !props.trackingGroupObject?.manager_user_ids?.length 
                // || props.trackingGroupObject?.tracker_user_ids?.length == 0
                || !props.trackingGroupObject?.tracked_user_ids?.length 
            )
        ) {
            fetchTrackingGroup();
        }
    }

    
})

</script>